module.exports = __webpack_public_path__ + "static/media/Rental.2f5ebf86.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/Rental.png
// module id = 3039
// module chunks = 0